export default __webpack_public_path__ + "static/media/Custom.9f7f50b3.svg";